import type DisplayOrder from 'owa-people-types/lib/types/DisplayOrder';
import {
    sortBy,
    UnifiedGroup,
    deletedUnifiedGroupsLeftNavId,
    ownedUnifiedGroupsLeftNavId,
} from '../../../shared';
import { getExpiryInDays } from './expiryInDays';

export function compareByRelevancy(
    locale: string,
    displayOrder: DisplayOrder,
    activeLeftNavItemId: string
): (left: UnifiedGroup, right: UnifiedGroup) => number {
    switch (activeLeftNavItemId) {
        case deletedUnifiedGroupsLeftNavId:
            return compareByDeletedDate(locale);
        case ownedUnifiedGroupsLeftNavId:
            return compareByNeedsActionAndRelevancy(locale, displayOrder);
        default:
            return compareByGivenRelevancyAndRelevancy(locale);
    }
}

export function compareByGivenNameAndSurname(
    locale: string,
    displayOrder: DisplayOrder
): (left: UnifiedGroup, right: UnifiedGroup) => number {
    return sortBy<UnifiedGroup>(
        locale,
        persona => [persona.displayName],
        element => element.displayName
    );
}

export function compareByNeedsActionAndRelevancy(
    locale: string,
    displayOrder: DisplayOrder
): (left: UnifiedGroup, right: UnifiedGroup) => number {
    // Making sort ascending order of expiring days by keeping an offset
    const maxExpiryDays = 2147483647;

    return sortBy<UnifiedGroup>(
        locale,
        persona => [
            persona.isExpiring ? maxExpiryDays - getExpiryInDays(persona) : 0,
            persona.pendingMembershipRequests,
            persona.relevancyScore,
        ],
        element => element.relevancyScore,
        true
    );
}

export function compareByGivenRelevancyAndRelevancy(
    locale: string
): (left: UnifiedGroup, right: UnifiedGroup) => number {
    return sortBy<UnifiedGroup>(
        locale,
        persona => [persona.relevancyScore],
        element => element.relevancyScore,
        true
    );
}

export function compareByDeletedDate(
    locale: string
): (left: UnifiedGroup, right: UnifiedGroup) => number {
    return sortBy<UnifiedGroup>(
        locale,
        persona => [persona.whenSoftDeletedTime],
        element => element.whenSoftDeletedTime
    );
}
